import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Bank, ArrowRight } from "@phosphor-icons/react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const StripeSetupBanner = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [status, setStatus] = useState(null);
  useEffect(() => {
    if (!user || user.role !== "trainer") return;
    api.get("/connect/coach/status").then(({ data }) => setStatus(data)).catch(() => {});
  }, [user, location.pathname]);
  if (!status || status.payments_ready || location.pathname.startsWith("/trainer/settings")) return null;
  return (
    <div className="border-b border-amber-500/30 bg-amber-500/5" data-testid="stripe-setup-banner">
      <div className="max-w-[1600px] mx-auto px-6 py-2.5 flex items-center justify-between gap-4 flex-wrap">
        <p className="text-xs text-amber-200 flex items-center gap-2">
          <Bank size={14} weight="duotone" /> Finish business setup: link your Stripe account so bookings, packs and invoices are paid upfront straight to you.
        </p>
        <Link to="/trainer/settings" className="tracker text-[10px] text-amber-300 inline-flex items-center gap-1 hover:underline" data-testid="stripe-setup-banner-link">
          Link Stripe <ArrowRight size={11} />
        </Link>
      </div>
    </div>
  );
};
